import { Trans } from '@lingui/react/macro';
import { motion } from 'framer-motion';

export default function LandedCompanies() {
  const companies = [
    { name: 'Microsoft', logo: '/images/companies/landing-logo-microsoft.webp', width: 144, height: 32 },
    { name: 'Amazon', logo: '/images/companies/landing-logo-amazon.webp', width: 106, height: 32 },
    { name: 'Google', logo: '/images/companies/landing-logo-google.webp', width: 106, height: 32 },
    { name: 'Meta', logo: '/images/companies/landing-logo-meta.webp', width: 140, height: 28 },
    { name: 'Tesla', logo: '/images/companies/landing-logo-tesla.webp', width: 146, height: 20 },
  ];

  // Duplicate companies for seamless infinite scroll
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <section className="py-8 sm:py-16 bg-white">
      <div className="max-w-[1080px] mx-auto px-4">
        {/* Title */}
        <motion.p
          className="text-center text-gray-500 text-base sm:text-lg mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Trans>Used for 10,000+ Job Interviews</Trans>
        </motion.p>

        {/* Company Logos – Desktop: Static */}
        <motion.div
          className="hidden sm:flex flex-wrap items-center justify-center gap-12 lg:gap-16 mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {companies.map((company) => (
            <img
              key={company.name}
              src={company.logo}
              alt={company.name}
              style={{ width: company.width, height: company.height }}
              className="object-contain"
            />
          ))}
        </motion.div>

        {/* Company Logos – Mobile: Infinite Scroll */}
        <motion.div
          className="sm:hidden relative overflow-hidden mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {/* Gradient fade on edges */}
          <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

          {/* Scrolling container */}
          <div className="flex items-center w-max animate-scroll-infinite">
            {duplicatedCompanies.map((company, index) => (
              <div
                key={`${company.name}-${index}`}
                className="flex-shrink-0 px-4"
              >
                <img
                  src={company.logo}
                  alt={company.name}
                  style={{ width: company.width, height: company.height }}
                  className="object-contain"
                />
              </div>
            ))}
          </div>
        </motion.div>

        {/* CTA Text */}
        {/* <motion.h2
          className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-dark-blue"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Trans>Land your next job</Trans>{' '}
          <span className="italic text-brand-gold"><Trans>effortlessly</Trans></span>{' '}
          <span className="inline-block">👍</span>
        </motion.h2> */}
         <motion.h2
          className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-dark-blue"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Trans>Land your</Trans>{' '}
          <span className="italic text-brand-gold"><Trans> dream job </Trans></span>{'🚀'}
           {/* <Trans>effortlessly</Trans>{' '} */}
          {/* <span className="inline-block">👍</span> */}
        </motion.h2>
      </div>
    </section>
  );
}
